import React, { useState } from "react";
import "./Login.css";
import { LoginCall } from "../../api/Auth";
import { useNavigate, useSearchParams } from 'react-router-dom';

const StationLogin = () => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const [credentials, setCredentials] = useState({
        username: "",
        password: ""
    });
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(
        searchParams.get('expired') === '1' ? "Your session has expired. Please log in again." : null
    );

    const handleChange = (e) => {
        setCredentials({ ...credentials, [e.target.name]: e.target.value });
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        LoginCall(credentials)
            .then((response) => {
                const data = response?.data?.data;
                const token = data?.access_token;
                if (token) {
                    localStorage.setItem('token', token);
                    const user = data?.user || {};
                    const role = user.role || 'client';
                    localStorage.setItem('user_role', role);
                    localStorage.setItem('user_info', JSON.stringify(user));

                    const tvId = user.tv_id || '';
                    if (tvId) {
                        localStorage.setItem('client_tv_id', String(tvId));
                        localStorage.setItem('nanba_selected_station_id', String(tvId));
                    }
                    navigate('/station');
                } else {
                    setError("Invalid response received from server.");
                }
            })
            .catch((err) => {
                console.error("Station login failed:", err);
                setError(err.response?.data?.message || "Invalid station credentials. Please verify your login.");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className="login-page-container">
            <div className="login-card">
                {/* Brand Header */}
                <div className="login-brand-header">
                    <div className="login-brand-icon icon-client">
                        <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                            <rect x="2" y="7" width="20" height="15" rx="2" ry="2" />
                            <polyline points="17 2 12 7 7 2" />
                            <line x1="8" y1="14" x2="8.01" y2="14" strokeWidth="3" />
                            <line x1="12" y1="14" x2="16" y2="14" />
                        </svg>
                    </div>
                    <h1>TV Station Owner Portal</h1>
                    <p>Manage your channel stream, banner ads & station details</p>
                </div>

                {/* Scope Notice Badge */}
                <div className="portal-scope-badge">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2">
                        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                    </svg>
                    <span>Dedicated Single TV Station Access Only</span>
                </div>

                {error && (
                    <div className="login-error-banner" style={{ marginBottom: "18px" }}>
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="12" y1="8" x2="12" y2="12"></line>
                            <line x1="12" y1="16" x2="12.01" y2="16"></line>
                        </svg>
                        <span>{error}</span>
                    </div>
                )}

                <form onSubmit={handleSubmit} className="login-form">
                    <div className="login-form-group">
                        <label>Station Code / Username / Email</label>
                        <input
                            type="text"
                            name="username"
                            className="login-input"
                            value={credentials.username}
                            onChange={handleChange}
                            placeholder="Enter station code, username, or email"
                            autoComplete="username"
                            required
                        />
                    </div>

                    <div className="login-form-group">
                        <label>Password</label>
                        <input
                            type="password"
                            name="password"
                            className="login-input"
                            value={credentials.password}
                            onChange={handleChange}
                            placeholder="Enter password"
                            autoComplete="current-password"
                            required
                        />
                    </div>

                    <button
                        type="submit"
                        className="login-submit-btn btn-client"
                        disabled={loading}
                    >
                        {loading ? "Verifying Station Access..." : "Sign In to Station Studio →"}
                    </button>
                </form>
            </div>
        </div>
    );
};

export default StationLogin;
